<div ngbDropdown container="body" class="dropdown flex-sm-column flex-lg-column">
  <label *ngIf="labelText" [for]="inputId" class="form-control-label">{{
    labelText | titlecase
  }}</label>
  <div class="d-flex" [ngClass]="{ 'flex-row': isHorizontal, 'flex-column': !isHorizontal }">
    <div class="d-flex flex-column" *ngIf="!readOnly">
      <input
        type="text"
        class="form-control dropdown-toggle dropdown"
        [class.w-100]="!isHorizontal"
        [class.custom-invalid]="isInvalid && control.touched"
        (blur)="onBlur()"
        (focus)="onFocus()"
        data-boundary="viewport"
        [disabled]="isDisabled"
        [id]="inputId"
        [name]="name"
        (input)="onInput($event)"
        [ngModel]="inputValue"
        (keyup)="onKeyUp($event)"
        [placeholder]="placeholderValue"
        [tabindex]="inputTabIndex"
        autocomplete="off" />

      <!--    The actual form field is hidden so that we can send the LookupUser object rather than just a string-->
      <span ngbDropdownToggle style="visibility: hidden; display: block"></span>
      <input hidden [formControl]="control" />

      <div id="{{ inputId }}-userList" ngbDropdownMenu class="dropdown-menu">
        <a
          class="dropdown-item"
          *ngFor="let user of list; let first = first"
          ngbDropdownItem
          (click)="selectUser(user)"
          [class.border-0]="first"
          >{{ user.displayName }} <span *ngIf="user.mail">&nbsp;- {{ user.mail }}</span></a
        >
        <a
          class="dropdown-item border-0 list-no-search"
          *ngIf="!loading && list?.length === 0 && (this.searchTerm?.length ?? 0) > 2"
          ngbDropdownItem>
          {{ noSearchResultText }} for search term : <b>&nbsp; "{{ this.searchTerm }}"</b>
        </a>
        <a
          class="dropdown-item border-0 list-loader"
          *ngIf="loading"
          ngbDropdownItem
          style="pointer-events: none">
          <div class="d-flex justify-content-center align-items-center w-100">
            <div class="loading"></div>
          </div>
        </a>
      </div>
    </div>

    <div *ngIf="isMultiSelect && displayBadge">
      <ng-container
        *ngIf="
          readOnly && control.value.length === 0;
          then readOnlyBlock;
          else selectedUsersBlock
        "></ng-container>
      <ng-template #readOnlyBlock>
        <div class="empty-list-text">
          {{ emptyListText }}
        </div>
      </ng-template>
      <ng-template #selectedUsersBlock>
        <div
          class="filters-selected d-sm-block d-lg-inline-block mt-sm-0"
          [ngClass]="{ 'mt-lg-3 py-2': !isHorizontal, 'ms-lg-3 px-2': isHorizontal }">
          <button
            type="button"
            [disabled]="isDisabled || readOnly"
            (click)="removeUser(v)"
            *ngFor="let v of control.value"
            class="badge btn me-2 mb-2"
            ngClass="{{
              readOnly ? 'btn-readonly' : isNewUser(v) ? 'btn-newly-added' : 'btn-already-exists'
            }}">
            <span>{{ v.displayName }}</span>
            <span class="ps-3" *ngIf="!readOnly">×</span>
          </button>
        </div>
      </ng-template>
    </div>
  </div>
</div>
